/**
 * Pricing section functionality
 * Handles voter count selection and monthly/annual billing toggle
 */

// Pricing data structure - matches the original HTML pricing
const PRICING_DATA = {
  starter: {
    0: { monthly: 99, annual: 299 },
    150000: { monthly: 299, annual: 299 },
    300000: { monthly: 399, annual: 399 }
  },
  standard: {
    0: { monthly: 199, annual: 399 },
    150000: { monthly: 399, annual: 399 },
    300000: { monthly: 499, annual: 499 }
  },
  pro: {
    0: { monthly: 299, annual: 499 },
    150000: { monthly: 499, annual: 499 },
    300000: { monthly: 599, annual: 599 }
  }
};

/**
 * Initialize pricing functionality
 */
function initPricing() {
  const voterRadios = document.querySelectorAll('.pricing__voter-radio');
  const billingCheckboxes = document.querySelectorAll('.plan__billing-checkbox');
  const billingButtons = document.querySelectorAll('.plan__billing-btn');

  // Handle voter count selection
  voterRadios.forEach(radio => {
    radio.addEventListener('change', handleVoterCountChange);
  });

  // Handle billing toggle
  billingCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', handleBillingToggle);
  });

  // Handle billing button clicks
  billingButtons.forEach(button => {
    button.addEventListener('click', handleBillingButtonClick);
  });

  // Initialize with default values
  //updatePrices();
}

/**
 * Handle voter count change
 */
function handleVoterCountChange(event) {
  //updatePrices();
}

/**
 * Handle billing toggle switch
 */
function handleBillingToggle(event) {
  const checkbox = event.target;
  const planCard = checkbox.closest('.plan');
  const monthlyBtn = planCard.querySelector('[data-billing="monthly"]');
  const annualBtn = planCard.querySelector('[data-billing="annual"]');

  if (checkbox.checked) {
    monthlyBtn?.classList.remove('plan__billing-btn--active');
    annualBtn?.classList.add('plan__billing-btn--active');
  } else {
    monthlyBtn?.classList.add('plan__billing-btn--active');
    annualBtn?.classList.remove('plan__billing-btn--active');
  }

  //updatePrices();
}

/**
 * Handle billing button click
 */
function handleBillingButtonClick(event) {
  const button = event.target.closest('.plan__billing-btn');
  if (!button) return;

  const planCard = button.closest('.plan');
  const checkbox = planCard.querySelector('.plan__billing-checkbox');
  const billingType = button.getAttribute('data-billing');

  if (billingType === 'annual') {
    checkbox.checked = true;
  } else {
    checkbox.checked = false;
  }

  // Trigger change event to update UI
  checkbox.dispatchEvent(new Event('change'));
}

/**
 * Update prices based on selected voter count and billing period
 */
function updatePrices() {
  const selectedVoterCount = document.querySelector('.pricing__voter-radio:checked')?.value || '0';
  const voterCount = parseInt(selectedVoterCount, 10);

  // Update each plan
  ['starter', 'standard', 'pro'].forEach(planType => {
    const planCard = document.querySelector(`.plan--${planType}`);
    if (!planCard) return;

    const checkbox = planCard.querySelector('.plan__billing-checkbox');
    const isAnnual = checkbox?.checked || false;
    const priceKey = isAnnual ? 'annual' : 'monthly';
    
    const price = PRICING_DATA[planType][voterCount]?.[priceKey] || PRICING_DATA[planType][0][priceKey];
    
    
    const monthlyPriceEl = planCard.querySelector('.plan__price-monthly');
    const annualPriceEl = planCard.querySelector('.plan__price-annual');

    const monthlyPriceOriginalEl =  planCard.querySelector('.plan__price-original');

    if (isAnnual) {
      if (monthlyPriceEl) monthlyPriceEl.style.display = 'none';
      if (annualPriceEl) {
        annualPriceEl.style.display = 'block';
        annualPriceEl.textContent = `$${price}`;
      }
    } else {
      if (monthlyPriceEl) {
        monthlyPriceEl.style.display = 'block';
        monthlyPriceEl.textContent = `$${price}`;

        monthlyPriceOriginalEl.style.display = 'block';
        monthlyPriceOriginalEl.textContent = `$${price + 200}`;
      }
      if (annualPriceEl) annualPriceEl.style.display = 'none';
    }
  });
}


/* ----------------------------------
   SUBSCRIBE URL HANDLER (ADD ONLY)
---------------------------------- */

const ADMIN_REGISTER_URL = 'https://admin.electhq.net' + '/register';

function buildSubscribeUrl(planCard) {
  // plan type from class: plan--starter / plan--standard / plan--pro
  const planType =
    planCard.classList.contains('plan--starter') ? 'local' :
    planCard.classList.contains('plan--standard') ? 'regional' :
    planCard.classList.contains('plan--pro') ? 'statewide' :
    'unknown';

  // voter count
  const selectedVoter =
    document.querySelector('.pricing__voter-radio:checked')?.value || '0';

  // billing type
  const billingCheckbox = planCard.querySelector('.plan__billing-checkbox');
  const billing = billingCheckbox?.checked ? 'annual' : 'monthly';

  // price already rendered by YOUR logic
  const priceEl =
    billing === 'annual'
      ? planCard.querySelector('.plan__price-annual')
      : planCard.querySelector('.plan__price-monthly');

  const price = priceEl?.textContent.replace('$', '') || '';

  // build URL
  const params = new URLSearchParams({
    plan: planType,
    voters: selectedVoter,
    billing,
    price
  });

  console.log(params.toString())

  //return "#";

  let url = `${ADMIN_REGISTER_URL}?${params.toString()}`;

  //console.log(url)

  return url;
}

/* ----------------------------------
   ATTACH CLICK EVENTS
---------------------------------- */
document.querySelectorAll('.js-subscribe-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    const planCard = btn.closest('.plan');
    if (!planCard) return;

    const url = buildSubscribeUrl(planCard);
    window.location.href = url;
  });
});

/* ----------------------------------
   FREE TRIAL (OPTIONAL)
---------------------------------- */
document.querySelectorAll('.js-free-trial').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    window.location.href = `${ADMIN_REGISTER_URL}?trial=true`;
  });
});



 /* ======================================================
   NEW PLAN CARD BILLING TOGGLE (ADD-ONLY)
   Monthly ↔ Annual per card
====================================================== */

document.querySelectorAll('.plan').forEach(plan => {
  const checkbox = plan.querySelector('.plan__billing-checkbox');
  const priceEl = plan.querySelector('.plan__price');
  const labels = plan.querySelectorAll('.plan__billing-label');

  if (!checkbox || !priceEl || labels.length !== 2) return;

  const formatUSD = value =>
    '$' + Number(value).toLocaleString();

  const updatePlanPrice = () => {
    const isAnnual = checkbox.checked;
    const value = isAnnual
      ? priceEl.dataset.annual
      : priceEl.dataset.monthly;

    if (value) {
      priceEl.textContent = formatUSD(value);
    }

    // label active state
    labels[0].classList.toggle('active', !isAnnual);
    labels[1].classList.toggle('active', isAnnual);
  };

  // ✅ checkbox toggle
  checkbox.addEventListener('change', updatePlanPrice);

  // ✅ label click support
  labels.forEach((label, index) => {
    label.addEventListener('click', () => {
      checkbox.checked = index === 1; // Annually
      updatePlanPrice();
    });
  });

  // ✅ initialize
  updatePlanPrice();
});



// Export for use in main.js
window.initPricing = initPricing;

